import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import ArticleSection from './components/ArticleSection';
import AdvantageSection from './components/AdvantageSection';
import PromotionSection from './components/PromotionSection';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <ArticleSection />
        <AdvantageSection />
        <PromotionSection />
        <FAQSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}